import axios from 'axios';
import { API_BASE_URL } from '../../lib/session';
import { rightsOf, worksOnUnit } from '../../lib/permissions';

const BASE = `${API_BASE_URL}/api/patients`;

export const errorMessage = (error, fallback) =>
  (error && error.response && error.response.data && error.response.data.message) || fallback;

export const fetchPatient = (id) => axios.get(`${BASE}/${id}`).then((response) => response.data);
export const createPatient = (data) => axios.post(BASE, data).then((response) => response.data);
export const updatePatient = (id, data) => axios.put(`${BASE}/${id}`, data).then((response) => response.data);
export const transferPatient = (id, unit) => axios.post(`${BASE}/${id}/transfer`, { unit }).then((response) => response.data);
export const deletePatient = (id) => axios.delete(`${BASE}/${id}`);

const ACTIONS = ['voir', 'modifier', 'supprimer', 'tout'];
const reaches = (rights, action) => Boolean(rights.patients) && ACTIONS.indexOf(rights.patients) >= ACTIONS.indexOf(action);

// What the account may do on the list and on one file (the server checks the same rules).
export const patientAccess = (user, patient) => {
  const rights = rightsOf(user);
  const ownUnit = !patient || worksOnUnit(user, patient.services);
  return {
    canCreate: reaches(rights, 'modifier'),
    canEdit: reaches(rights, 'modifier') && ownUnit,
    canDelete: reaches(rights, 'supprimer') && ownUnit,
    canPrint: reaches(rights, 'tout'),
    // Progress notes: anyone who may edit files, whatever the unit (as before).
    canWriteNotes: reaches(rights, 'modifier'),
    otherUnit: reaches(rights, 'modifier') && !ownUnit,
  };
};
